const menuList = [
    [
        {
            title:"招商管理系统",
            img:require("../assets/index_img/zs.png"),
            text:"展示县区招商领域的关键信息，辅助管理者全面掌控区县地块、厂房、楼宇态势",
            nav:"招商管理系统",
            pth:""
        },
        {
            title:"涉农产业系统",
            img:require("../assets/index_img/sn.png"),
            text:"关注农村产业，辅助提升农村产业发展，打造乡村振兴的数字化阵地",
            nav:"涉农产业系统",
            pth:"/xfbf/#"
        },
        {
            title:"勉县经济区划管理系统",
            img:require("../assets/index_img/jj.png"),
            text:"展示县区企业信息展示、产业经济全景洞察，实时掌握企业生产及运营情况",
            nav:"勉县经济区划管理系统",
            pth:""
        },
        {
            title:"企业家",
            img:require("../assets/index_img/qyj.png"),
            text:"全面掌握在外/来勉企业家动态，为勉县所有企业家提供一个线上交流交互的空间",
            nav:"企业家",
            pth:""
        },
        {
            title:"智慧旅游平台",
            img:require("../assets/index_img/ly.png"),
            text:"提升旅游智慧水平，改善旅游环境，优化游客体验。推进勉县汉文化资源库建设及文化旅游融合发展，塑造勉县旅游文化的展示区",
            nav:"智慧旅游平台",
            pth:"/ly/#"
        },
        {
            title:"亲商助企系统（融合服务)",
            img:require("../assets/index_img/rh.png"),
            text:"实时掌握企业诉求情况，为企业提供“生产经营”全闭环流程服务",
            nav:"亲商助企系统（融合服务)",
            pth:"/zhyq/#"
        }
    ],
    [
        {
            title:"勉县督办考核系统",
            img:require("../assets/index_img/zhzl.png"),
            text:"勉县政府结合工作需要，通过互联网发布工作任务，各相关单位可将任务完成情况通过系统进行上报，系统具备自动化考核打分能力，帮助政府进一步细化工作责任，抓实抓细工作作风。",
            nav:"勉县督办考核系统",
            pth:"/dflz/#"
        },
        {
            title:"综合执法系统",
            img:require("../assets/index_img/zhzf.png"),
            text:"围绕综合执法协同业务，形成“发起—处置—评分—分析”的全闭环业务流程",
            nav:"综合执法系统",
            pth:"/zhshj/#"
        },
        {
            title:"非公党建系统",
            img:require("../assets/index_img/fgdj.png"),
            text:"实施一企一码，将非公党建工作融入企业发展全过程，为服务非公经济高质量发展提供坚强组织保障",
            nav:"非公党建系统",
            pth:"/fgdj/#"
        },
        {
            title:"重点项目管理系统",
            img:require("../assets/index_img/zdxm.png"),
            text:"以智能化、数字化全面提高行政效能，以信息化手段管理重点建设项目，保障项目顺利推进",
            nav:"重点项目管理系统",
            pth:"/zdjsxm/#"
        },
        {
            title:"乡村振兴项目管理系统",
            img:require("../assets/index_img/xczx.png"),
            text:"针对乡村振兴“财政衔接补助资金”，分级分类进行相关项目的流程化管理",
            nav:"乡村振兴项目管理系统",
            pth:"/xmgli/#"
        },
        {
            title:"乡村振兴资产管理系统",
            img:require("../assets/index_img/zcgl.png"),
            text:"针对乡村振兴过程中产生的各类资产进行归档管理，并跟踪其终身使用情况",
            nav:"乡村振兴资产管理系统",
            pth:"/fangfp/#"
        }
    ],
    [
        {
            title:"重点人服务系统",
            img:require("../assets/index_img/zdr.png"),
            text:"对重点人员的动态管理和控制，根据重点人员档案信息，实现有效的数据挖掘分析和管理服务",
            nav:"重点人服务系统",
            pth:"/zhshj/#"
        },
        {
            title:"信访大数据",
            img:require("../assets/index_img/xf.png"),
            text:"依托系统收集的海量民声数据，对信访形势分析研判，对于各类形势异常，第一时间向相关部门发送预警提示，辅助做好排查化解工作，做到抓早抓小、精准化解",
            nav:"信访大数据",
            pth:"/zhshj/#"
        },
        {
            title:"公共卫生防控系统",
            img:require("../assets/index_img/yqfk.png"),
            text:"通过信息化手段解决公共卫生相关各类信息的实时管理和交互，形成闭环管理。系统通过数据中台的智能化处理，为基层工作人员减轻负担，提升防控工作效率，方便公共卫生指挥部门使用与快速响应",
            nav:"公共卫生防控系统",
            pth:"/yqfk/#"
        },
        {
            title:"防返贫系统",
            img:require("../assets/index_img/ffp.png"),
            text:"",
            nav:"防返贫系统",
            pth:"/fangfp/#"
        },
        {
            title:"应急指挥辅助决策系统",
            img:require("../assets/index_img/yjzh.png"),
            text:"针对自然灾害、事故灾难、社会安全事件和公共卫生事件的突发事件应急辅助指挥管理平台",
            nav:"应急指挥辅助决策系统",
            pth:"/yj/#"
        },
        {
            title:"矛盾纠纷多元化解平台",
            img:require("../assets/index_img/mdjf.png"),
            text:"建立党委领导下的人民调解、行政调解、司法调解等多元调解服务体系，让人民群众解决纠纷“最多跑一地”，努力实现“小事不出社区，大事不出街道，难事不出城区”",
            nav:"矛盾纠纷多元化解平台",
            pth:"/zhshj/#"
        }
    ]
]

export default  menuList 